import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import CKEditor from "react-ckeditor-component";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import $ from 'jquery';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';

class Noteokredit extends Component {
    constructor(props) {
        super(props);
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            owners: [],
            apiUrl: this.decryptconfigdata('apiUrl'),
            userId: has_local_data ? localdata.user_id : '',
            userName: has_local_data ? localdata.user_name : '',
            userAuthKey: has_local_data ? localdata.user_key : '',
            NoteEdit: localStorage.getItem('ticket_note'),
            message: '',
        }
        this.ckOnChange = this.ckOnChange.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    goBack() {
        window.history.back();
    }

    ckOnChange(evt) {
        var ckContent = evt.editor.getData();
        if (this.state.NoteEdit.toLowerCase() != ckContent.toLowerCase()) {
            this.setState({
                NoteEdit: ckContent
            })
            var obj = this;
            setTimeout(function () {
                ckContent = ckContent.replace(/<\/p>$/, "");
                var nameRegex = /@[a-zA-Z]+$/;
                var matches = ckContent.match(nameRegex);
                if (matches && matches.length > 0) {
                    var indx = matches['index'];
                    var query = matches[0].replace('@', '');
                    if (query) {
                        var result = [];
                        var filterObj = obj.state.owners.filter(function (e) {
                            if (e.name.toLowerCase().includes(query.toLowerCase())) {
                                result.push(e.name);
                            }
                        });
                        var mtchitems = '';
                        if (result.length > 0) {
                            for (var i in result) {
                                mtchitems += '<li class="auto-suggest-li" style="padding:5px;cursor:pointer;background:#ccc;margin-bottom:1px;" >' + result[i] + '</li>';
                                if (i == result.length - 1) {
                                    mtchitems = '<ul style="list-style:none" class="auto-suggest-ul">' + mtchitems + '</ul>';
                                    document.getElementById('note_autoseggestion').innerHTML = mtchitems;
                                    $('.auto-suggest-li').on('click', function (event) {
                                        var final_string = ckContent.substring(0, indx) + "@" + event.target.innerText.trim();
                                        evt.editor.setData(final_string);
                                        obj.setState({
                                            NoteEdit: final_string
                                        })
                                        document.getElementById('note_autoseggestion').innerHTML = "";
                                        evt.editor.focus();
                                    });
                                }
                            }
                        } else {
                            document.getElementById('note_autoseggestion').innerHTML = "";
                        }
                    }
                } else {
                    document.getElementById('note_autoseggestion').innerHTML = "";
                }
            }, 300);
        } else {
            evt.editor.focus();
        }
    }

    updateOkrNote() {
        document.getElementById("add_note").innerHTML = "Sending....";
        const fd = new FormData;
        document.getElementById("add_note").disabled = true;
        fd.append('note', this.state.NoteEdit);
        fetch(this.state.apiUrl + '/OkrRest/updateNoteOkr/id/' + this.props.match.params.id + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                //console.log(findresponse);
                document.getElementById("add_note").disabled = false;
                document.getElementById("add_note").innerHTML = "update";
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        window.location.href = '/Updateokr/' + this.state.snippet_id;
                    });
                } else {
                    this.setState({ message: findresponse.msg })
                }
            })
    }

    getnoteDetails() {
        fetch(this.state.apiUrl + '/OkrRest/NoteOkrEdit/id/' + this.props.match.params.id + '/userAuthKey/' + this.state.userAuthKey)
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                console.log(findresponse)
                this.setState({
                    NoteEdit: findresponse.notedetails,
                    owners: findresponse.owners,
                    snippet_id: findresponse.snippet_id,
                })
            })
    }

    componentWillMount() {
       document.title = "Intranet | Edit Note";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.getnoteDetails();
    }

    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div>
                <Header brecum_name="er" brecum_page="OKR" NoteEdit={this.state.NoteEdit} />
                <div class="right_col">
                    <div class="intranet_body">
                        <div class="title mob"><HeaderMob page_name="OKR" /></div>
                        <div class="top-row-form">
                            <div class="form-group">
                                <label></label>
                                <CKEditor
                                    activeClass="p10"
                                    content={this.state.NoteEdit}
                                    events={{
                                        "change": this.ckOnChange
                                    }}
                                />
                                <div id='note_autoseggestion'></div>
                            </div>
                            <button type="submit" name="add_note" id="add_note" className="btn btn-sky mob-btn" onClick={() => this.updateOkrNote()}>Update</button>
                            <button type="button" className="btn btn-blue" onClick={() => this.goBack()} >Back</button>
                            <div className="clear"></div>
                        </div>
                    </div>
                    <span style={{ color: "red" }}>{this.state.message}</span>
                </div>
            </div>
        )
    }
}
export default Noteokredit;


// WEBPACK FOOTER //
// ./src/components/okr/noteokredit.js